
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgotpassword",
      function () {
        return require("private-next-pages/forgotpassword/index.js");
      }
    ]);
  